import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Place Order</strong> to begin the ordering wizard. Select the order type and follow the guided steps to complete your purchase." id="click_place_order_to_begin_the_ordering.7cca5eca" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Starting an Order" id="starting_an_order.404d62b2" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Choose between <strong>Normal</strong> orders (direct purchase) and <strong>Proxy</strong> orders (on behalf of another partner). Proxy orders may offer autofill from previous orders." id="choose_between_normal_orders_direct_purc.bb4db4a7" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Order Types" id="order_types.f86f319f" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Review your selections before submitting. Ensure quantities and license types are correct — <strong>submitted orders will begin processing immediately.</strong>" id="review_your_selections_before_submitting.ff09de6a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Completing the Order" id="completing_the_order.6f8499d1" />
        }
    ],
    title: <FormattedMessage defaultMessage="Place Order" id="place_order.0da32b8f" />
};
